import {DomainObject} from 'shared/store';
import { observable, computed, makeObservable } from 'mobx';
import {t} from 'shared/core';

class PerformanceReviewQuestionWithType extends DomainObject {
  id;
  questionName;
  questionOptions;
  type;

  constructor(other) {
    super();

    makeObservable(this, {
      id: observable,
      questionName: observable,
      questionOptions: observable,
      type: observable,
      displayType: computed,
      name: computed
    });

    this.merge(other);
  }

  get displayType() {
    return t(`models.performance_reviews.type.${this.type}`);
  }

  get name() {
    return `${this.questionName} (${this.displayType})`;
  }
}

export default PerformanceReviewQuestionWithType;
